import { isNil } from 'lodash-es'
import { findEpiSuiteGroupById } from '@/components/combined-predict/models/epiSuite/epiSuiteColumnGroups'
import { getSummaryValue, buildDisplayPairRow, makeFactorTable } from '../utils'
import { mapUnitOrOriginal } from '@/components/combined-predict/components/CombinedPredictTable/utils/unitConversions'
import { getPredictionDataBySource } from '@/components/combined-predict/models/epiSuite/utils'

const defaultLKgUnit = 'L/kg wet-wt'
const logBCF = 'Log BCF'

const summaryMapper = (item, meta) => {
  const logBcfSummaryValue = getSummaryValue({ value: item?.logBioconcentrationFactor }, logBCF)
  const logBafSummaryValue = getSummaryValue({ value: item?.logBioaccumulationFactor }, 'Log BAF')

  const rows = (meta?.children ?? []).map((child) => {
    const value = getPredictionDataBySource(item, child.id)

    const unit = mapUnitOrOriginal(child?.unit) === 'L/kg' ? defaultLKgUnit : child?.unit

    return buildDisplayPairRow({ value: child?.name, belowText: child?.description }, { value: value, unit })
  })

  return {
    values: [logBcfSummaryValue, logBafSummaryValue],
    tables: [
      {
        headers: ['', ''],
        rows,
      },
    ],
  }
}

const descriptorsMapper = (item) => {
  const bioconcentrationFactors = item?.bioconcentrationFactors
  const biotransformationFactors = item?.biotransformationFactors
  const biotransformationHalfLife = item?.biotransformationHalfLife
  const logBioconcentrationFactor = item?.logBioconcentrationFactor
  const logBiotransformationHalfLife = item?.logBiotransformationHalfLife
  const tables = []

  if (bioconcentrationFactors?.length) {
    tables.push({
      ...makeFactorTable(bioconcentrationFactors, 'Bioconcentration Factor (BCF)'),
      footer: [buildDisplayPairRow(logBCF, { value: logBioconcentrationFactor, unit: defaultLKgUnit })],
    })
  }

  if (biotransformationFactors?.length) {
    const footer = []
    if (!isNil(logBiotransformationHalfLife))
      footer.push(
        buildDisplayPairRow('Log Bio Half-Life (days)', { value: logBiotransformationHalfLife, unit: 'days' }),
      )

    if (!isNil(biotransformationHalfLife))
      footer.push(
        buildDisplayPairRow('Bio Half-Life (days) - Normalized to 10 g fish at 15°C', biotransformationHalfLife),
      )

    tables.push({
      ...makeFactorTable(biotransformationFactors, 'Biotransformation Rate'),
      footer: footer.length ? footer : undefined,
    })
  }

  return { tables }
}

const bcfBaf = (items) => {
  const item = items?.find((i) => i?.property === 'bioconcentration')
  const meta = findEpiSuiteGroupById('bioconcentration')

  return {
    title: 'BCFBAF',
    description: 'Bioconcentration/Bioaccumulation Factor',
    helpPage: meta?.helpPage,
    summary: summaryMapper(item, meta),
    modelDescriptors: descriptorsMapper(item),
    modelOutput: item?.output,
  }
}

export { bcfBaf }
